import { createSlice } from '../wrappers';
import { IHandlingTuningPreset } from '~/shared';

const initialState = {
	maxTabIndex: 2,
	saveSelectedList: 'favorite',
	saveSelectedIndex: 0,
	saveFavoriteMaxIndex: 0,
	saveNonFavoriteMaxIndex: 0,
	savePresetList: [] as IHandlingTuningPreset[],
	saveAbsoluteIndex: 0,
};

const handlingListSlice = createSlice({
	name: 'handlingList',
	initialState,
	reducers: {
		setSaveSelectedIndex: (state, action) => {
			state.saveSelectedIndex = action.payload;
		},
		setSaveFavoriteMaxIndex: (state, action) => {
			state.saveFavoriteMaxIndex = action.payload;
		},
		setSaveNonFavoriteMaxIndex: (state, action) => {
			state.saveNonFavoriteMaxIndex = action.payload;
		},
		setSaveSelectedList: (state, action) => {
			state.saveSelectedList = action.payload;
		},
		setSaveSelectedIndexPrev: (state) => {
			let index = state.saveSelectedIndex;

			if (state.saveSelectedList === 'favorite') {
				index = index > 0 ? index - 1 : index;
				state.saveSelectedIndex = index;
			} else {
				if (index === 0) {
					if (state.saveFavoriteMaxIndex !== -1) {
						index = state.saveFavoriteMaxIndex;
						state.saveSelectedIndex = index;
						state.saveSelectedList = 'favorite';
					}
				} else {
					index = state.saveSelectedIndex - 1;
					state.saveSelectedIndex = index;
				}
			}
		},
		setSaveSelectedIndexNext: (state) => {
			let index = state.saveSelectedIndex;

			if (state.saveSelectedList === 'nonFavorite') {
				const maxIndex = state.saveNonFavoriteMaxIndex;
				index = index < maxIndex ? index + 1 : index;
				state.saveSelectedIndex = index;
			} else {
				if (index === state.saveFavoriteMaxIndex) {
					index = 0;
					state.saveSelectedIndex = index;
					state.saveSelectedList = 'nonFavorite';
				} else {
					index = state.saveSelectedIndex + 1;
					state.saveSelectedIndex = index;
				}
			}
		},
		setSavePresetList: (state, action) => {
			state.savePresetList = action.payload;
		},
		setSaveAbsoluteIndex: (state, action) => {
			state.saveAbsoluteIndex = action.payload;
		},
	},
});

export const {
	setSaveSelectedIndex,
	setSaveFavoriteMaxIndex,
	setSaveNonFavoriteMaxIndex,
	setSaveSelectedList,
	setSaveSelectedIndexPrev,
	setSaveSelectedIndexNext,
	setSavePresetList,
	setSaveAbsoluteIndex,
} = handlingListSlice.actions;

export default handlingListSlice.reducer;
